export const SET_ITEMS = 'app/product/SET_ITEMS';
export const SET_CATEGORIES = 'app/product/SET_CATEGORIES';
